import { cn } from "@repo/utils";

type Props = {
  title?: string;
  className?: string;
  children?: React.ReactNode;
};

export const TaskPanelItems = ({ title, className, children }: Props) => {
  return (
    <div
      className={cn(
        "border-gxe-border my-2 flex h-full items-center border-r px-4 text-sm",
        className,
        {
          "m-0 px-0": !children && !title,
        }
      )}
    >
      {title ? <span>{title}</span> : null}
      {children ? <div>{children}</div> : null}
    </div>
  );
};
